import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { map, find } from "lodash";
import Grid from "@mui/material/Grid";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import * as React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Box } from "@mui/system";
import Button from "@mui/material/Button";
import { TypeSpecimenOutlined } from "@mui/icons-material";
import { Typography } from "@mui/material";
import { currentAssetSliceActions } from "../../../Store/Slices/CurrentAssetSlice";
import {
  unicodeToString,
  getWords,
  concatAllArrays,
  shuffle,
} from "../../../Js/Common";
import IconButton from "@mui/material/IconButton";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import StatusIndicator from "../../../Components/Card/AssetUI/StatusIndicator";

var initLogObj = {
  attempts: 1,
  duration: 0,
  assetType: {
    group: "practice",
    value: null,
  },
  userAnswer: [],
  isEvaluated: "auto",
  actualAnswer: [],
  genericScore: 0,
};

const WORDGROUP = (props) => {
  // Hooks
  const dispatch = useDispatch();
  const classes = useStyles();

  // State
  let [userAnswer, setUserAnswer] = useState([]);
  let [logObj, setLogObj] = useState(initLogObj);
  let [words, setWords] = useState([]);
  let [currentBox, setCurrentBox] = useState(0);

  // Redux state
  const { showAnswer, assetLogObj, attempted, currentAttempt, optionWiseAns } =
    useSelector((state) => state.currentAsset);

  useEffect(() => {
    let innerFun = async () => {
      if (props.content) {
        let ids = map(props.content.epage.options.content, "words");
        let wordsData = await getWords(concatAllArrays(ids));
        shuffleWords(wordsData.data);
        setCurrentBox(0);
        setUserAnswer(
          new Array(props.content.epage.options.content.length).fill([])
        );
        dispatch(
          currentAssetSliceActions.setCurrentAttemptData(
            new Array(props.content.epage.options.content.length).fill([])
          )
        );
        setLogObj({
          ...logObj,
          assetType: {
            ...logObj.assetType,
            value: props.content.info.asset_type_alias,
          },
          actualAnswer: map(props.content.epage.options.content, "words"),
        });
      }
    };
    innerFun();
  }, [props.content]);

  useEffect(() => {
    dispatch(currentAssetSliceActions.setAssetLogObj(logObj));
    dispatch(currentAssetSliceActions.setShowAnswer(false));
  }, [logObj]);

  useEffect(() => {
    let resetwords = shuffle(concatAllArrays([...userAnswer]).concat(words));
    setWords(resetwords);
    setUserAnswer(
      new Array(props.content.epage.options.content.length).fill([])
    );
    dispatch(currentAssetSliceActions.setShowAnswer(false));
    dispatch(
      currentAssetSliceActions.setCurrentAttemptData(
        new Array(props.content.epage.options.content.length).fill([])
      )
    );
    setCurrentBox(0);
  }, [currentAttempt]);

  useEffect(() => {
    if (showAnswer && assetLogObj && assetLogObj.actualAnswer) {
      let concatAll = concatAllArrays([...userAnswer]).concat(words);
      let actualAns = assetLogObj.actualAnswer.map((val) => {
        return val.map((inner, index1) => {
          let foundObj = find(concatAll, (o) => {
            return o.item.uid == inner;
          });
          if (foundObj) {
            return foundObj;
          }
          return {};
        });
      });
      setUserAnswer(actualAns);
      setWords([]);
    }
  }, [showAnswer, assetLogObj]);

  useEffect(() => {
    return () => {
      setUserAnswer([]);
      setCurrentBox(0);
    };
  }, []);

  const shuffleWords = (words) => {
    let wordsData = words.map((val, index) => {
      return {
        id: "",
        item: {
          uid: val.uid,
          word: val.word_phrase,
          parts: typeof val.content == "string" ? JSON.parse(val.content):val.content,
        },
      };
    });
    shuffle(wordsData);
    setWords(wordsData);
  };

  const updateUserAnswer = (word, windex) => {
    if (!showAnswer && !attempted) {
      let newArray = [...userAnswer];
      newArray[currentBox] = [...newArray[currentBox], word];
      setUserAnswer(newArray);
      let newWords = [...words];
      newWords.splice(windex, 1);
      setWords(newWords);
      dispatch(currentAssetSliceActions.setCurrentAttemptData(newArray));
    }
  };

  const removeFromActualContent = (innerIndex, boxIndex) => {
    if (!showAnswer && !attempted) {
      let newArray = [...userAnswer];
      let word = newArray[boxIndex][innerIndex];
      let newWords = [...words, word];
      setWords(newWords);
      let innerArray = [...newArray[boxIndex]];
      innerArray.splice(innerIndex, 1);
      newArray[boxIndex] = innerArray;
      setUserAnswer(newArray);
      dispatch(currentAssetSliceActions.setCurrentAttemptData(newArray));
    }
  };

  return (
    <Grid item xs={12}  >
      {props.content && (
        <>
          <Box>
            <Grid
              container
              sx={{
                flexDirection: "row",
                mt: 1,
                borderBottom: 1,
                borderBottomColor: "#EFEFEF",
                py: 2,
              }}
            >
              {words &&
                words.length > 0 &&
                words.map((word, windex) => {
                  return (
                    <Grid item sx={{ ml: 1, cursor: "pointer", py: 1, px: 1 }}>
                      <Box sx={{}}>
                        <Button
                          variant="outlined"
                          sx={{
                            textTransform: "inherit",
                            borderRadius: 10,
                            borderColor: "#EFEFEF",
                            px: 2,
                          }}
                          onClick={() => {
                            updateUserAnswer(word, windex);
                          }}
                        >
                          <Typography
                            sx={{
                              fontWeight: "700",
                              fontSize: "0.9rem",
                              "@media (min-width: 1636px)": {
                                fontSize: "1.4rem",
                              },
                            }}
                          >
                            {word.item.word}
                          </Typography>
                        </Button>
                      </Box>
                    </Grid>
                  );
                })}
            </Grid>
          </Box>
          <Box>
            <Grid
               
              container
              sx={{ height: "34vh", mt: 2, overflow: "auto" }}
            >
              <Grid item xs={12}>
                <Grid
                  container
                  sx={{
                    backgroundColor: "#F5F7FF",
                    alignItems: "center",
                    borderRadius: 5,
                    py: 1,
                  }}
                >
                  {props.content.epage.options.content.map((val, index) => {
                    return (
                      <Grid
                        item
                        xs={12 / +props.content.epage.options.content.length}
                      >
                        <Typography
                          sx={{
                            color: "primary.main",
                            textAlign: "center",
                            fontWeight: "600",
                            fontSize: "0.9rem",
                            "@media (min-width: 1636px)": {
                              fontSize: "1.4rem",
                            },
                          }}
                        >
                          {unicodeToString(val.text)}
                        </Typography>
                      </Grid>
                    );
                  })}
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <Grid container sx={{ flexDirection: "row" }}>
                  {props.content.epage.options.content.map((val1, index2) => {
                    return (
                      <Grid
                        item
                        xs={12 / +props.content.epage.options.content.length}
                         
                        sx={{
                          borderLeft: index2 == 0 ? 2 : 0,
                          borderLeftColor:
                            index2 == 0
                              ? currentBox == index2
                                ? "primary.main"
                                : "#EFEFEF"
                              : "",
                          borderRight: 2,
                          borderRightColor:
                            currentBox == index2 || currentBox - 1 == index2
                              ? "primary.main"
                              : "#EFEFEF",
                          height: "26vh",
                          width: "100px",
                          display: "flex",
                          overflow: "auto",
                          flexDirection: "row",
                          flexWrap: "wrap",
                          alignContent: "flex-start",
                        }}
                        onClick={() => {
                          if (!showAnswer && !attempted) {
                            setCurrentBox(index2);
                          }
                        }}
                      >
                        {userAnswer[index2] &&
                          userAnswer[index2].map((selectedWord, innerIndex) => {
                            return (
                              <Box
                                sx={{
                                  border: 1,
                                  borderColor: "#D9D9D9",
                                  color: "primary.main",
                                  fontWeight: "700",
                                  fontSize: "0.9rem",
                                  borderRadius: 10,
                                  boxShadow: 0,
                                  width: "auto",
                                  cursor: "pointer",
                                  px: 1,
                                  marginX: 0.5,
                                  textAlign: "center",
                                  display: "flex",
                                  height: "fit-content",
                                  justifyContent: "space-around",
                                  alignItems: "center",
                                  "@media (min-width: 1636px)": {
                                    fontSize: "1.4rem",
                                    width: "auto",
                                    height: "2.8rem",
                                  },
                                  mb: 1,
                                }}
                              >
                                {optionWiseAns &&
                                  optionWiseAns.length > 0 &&
                                  optionWiseAns[index2] != undefined &&
                                  optionWiseAns[index2][innerIndex] != undefined && (
                                    <StatusIndicator
                                      correct={optionWiseAns[index2][innerIndex]}
                                    ></StatusIndicator>
                                  )}
                                <span>
                                  {selectedWord.item && selectedWord.item.word
                                    ? selectedWord.item.word
                                    : ""}
                                </span>
                                <IconButton
                                  edge="end"
                                  au6ria-label="comments"
                                  sx={{
                                    color: "#A9A9A9",
                                    textAlign: "right",
                                  }}
                                  onClick={() =>
                                    removeFromActualContent(innerIndex, index2)
                                  }
                                >
                                  <HighlightOffIcon
                                    sx={{
                                      fontSize: "1rem",
                                      "@media (min-width: 1636px)": {
                                        fontSize: "1.4rem",
                                      },
                                    }}
                                  />
                                </IconButton>
                              </Box>
                            );
                          })}
                      </Grid>
                    );
                  })}
                </Grid>
              </Grid>
            </Grid>
          </Box>
        </>
      )}
    </Grid>
  );
};
const useStyles = makeStyles({
  ListItemText: {
    fontSize: "1rem !important",
  },
  scrollBar: {
    "&::-webkit-scrollbar": {
      width: "0.2em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
    height: "62vh",
    overflow: "auto",
  },
  scrollBarHeight: {
    "&::-webkit-scrollbar": {
      height: "0.2em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
  },
});
export default WORDGROUP;
